import  { useReducer, useState, useEffect } from 'react';
import Input from '../../../../Input/Input.jsx';
import CustomButton from '../../../../Button/CustomButton.tsx';
import Checkboxx from '../../../../Checkbox/Checkboxx.jsx';
import { useNavigate } from 'react-router-dom';
import { StyledModalcomponentMuestras } from '../../../Styled.jsx';
import { getClienteOptions, importarExcel } from '../../../../../api/Clientes.js';
import { getAllOrdenByCliente } from '../../../../../api/Muestras.js';
import DropZoneExcel from '../../../../DropZone/DropZoneExcel.jsx';
import { useAuth } from '../../../../../context/AuthContext.jsx';
import Toast from '../../../../Toast/Toast.jsx';
import Preloader from '../../../../Preloader/Preloader.jsx';

const ImportacionDeResultadosModal = (props) => {
  // const propsImportacionResultados = (datosUnidades) => {

  //   return {}
  // }
  // const {} = propsImportacionResultados(props.datos);
  const { token } = useAuth();

  const navigate = useNavigate();
  const [formCompleto, setFormCompleto] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState(null);

  const [ordenes, setOrdenes] = useState([]);
  const [selectedOrden, setSelectedOrden] = useState(null);
  const [isLoadingOrdenes, setIsLoadingOrdenes] = useState(false);

  const [reemplazar, setReemplazar] = useState(false);

  const [rarFile, setRarFile] = useState([]);

  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [msjToast, setMsjToast] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [form, setForm] = useReducer((state, action) => {
    switch (action.type) {
      case 'SET_FIELD':
        return { ...state, [action.field]: action.value };
      default:
        return state;
    }
  }, {
    cliente: '',
    ordenTrabajo: '',
  });

  useEffect(() => {
    const fetchClientes = async () => {
      const res = await getClienteOptions();
      const unidades = res?.data?.map((item) => ({
        value: item.id,
        label: item.desc_cli,
      }));
      setClientes(unidades);

      if (token.clienteId !== "") {

        const matchOption = unidades.find(
          (option) => option.value === parseInt(token.clienteId, 10)
        );

        if (matchOption) {
          setSelectedCliente(matchOption)
          fetchOrdenes(matchOption);
        }

      }
    };

    fetchClientes();
  }, []);

  const fetchOrdenes = async (e) => {
    setOrdenes([]);
    setSelectedOrden(null);
    if (e === null) {
    } else {
      setIsLoadingOrdenes(true);
      const res = await getAllOrdenByCliente(e.value);
      const unidades = res?.data?.map((item) => ({
        value: item.id,
        label: `${item.desc_otra} #${item.nro_lote_otra}`,
        subLabel: item.estado.desc_ef_ot,
        code: item.codigo_otra,
        color: item.estado.color_ef_ot
      }));
      setOrdenes(unidades);
      setIsLoadingOrdenes(false);
    }
  };
  console.log(ordenes);
  useEffect(() => {
    const campoValido = campo => form[campo] !== '';
    const camposaValidar = ['cliente', 'ordenTrabajo'];
    const formularioCompleto = camposaValidar.every(campoValido);
    setFormCompleto(formularioCompleto);
  }, [form]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const fieldValue = value;
    setForm({ type: 'SET_FIELD', field: name, value: fieldValue });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  }
  const titulo = () => {
    const titulo = "Importación de Resultados"
    return titulo
  }
  const handleClickCancelar = () => {
    if (props.onClick) {
      props.onClick();
    }
    navigate(-1);
  };

  const handleOnUploadArchivo = (file) => {
    console.log(file[0]);
    setRarFile([...rarFile, file[0]]);
  }

  const handleDeleteArchivo = (file, index) => {
    setRarFile([])
  }

  const handleClickConfirmar = async () => {
    setIsLoading(true);
    try {
      const formData = new FormData();
      const blob = new Blob([rarFile[0].file], { type: 'application/octet-stream' });  // Especifica un tipo MIME adecuado
      formData.append('excel', blob, rarFile[0].nombre); // 'rarFile[0].nombre' es el nombre del archivo
      formData.append('reemplazarDatos', reemplazar);

      // Realizamos el post usando importarExcel
      const response = await importarExcel(formData);

      // Si todo fue exitoso, procesamos la respuesta
      setMsjToast(response?.data.mensaje || "Los resultados fueron cargados satisfactoriamente");
      setSuccess(true);
      setIsLoading(false);

      // Limpiamos los estados

      if (token.clienteId !== "") {
        setSelectedOrden(null);
        setRarFile([]);
      } else {
        setSelectedCliente(null);
        setOrdenes([]);
        setSelectedOrden(null);
        setRarFile([]);
      }

    } catch (err) {
      // En caso de error, manejamos el error con un mensaje
      console.log(err)
      const errorMessage = err.response?.data.mensaje || "Ocurrió un error al cargar los resultados";
      setMsjToast(errorMessage);
      setError(true);
      setIsLoading(false);
    }
  };


  const renderButtons = () => {
    return (
      <>
        <CustomButton
          onClick={handleClickCancelar}
          label={"Cancelar"}
          variant="contained"
          className={`buttonColorDisabled`}
        />

        <CustomButton
          onClick={handleClickConfirmar}
          label={"Confirmar"}
          variant="contained"
          className={`buttonColorDefault btn`}
          type="submit"
          disabled={selectedOrden === null}
        />
      </>
    );
  };
  const onFileChange = (file) => {
    console.log(file);
    setSelectedFile(file);
  };

  return (
    <StyledModalcomponentMuestras sx={{
      width: "60%",
      padding: "40px",
      '@media (max-width: 768px)': {
        width: "90%",
      },
    }}>
      <Preloader title="Cargando..."
        subtitle={"Espere unos Segundos por favor..."}
        loading={isLoading} />
      <div className="toast" style={{ zIndex: "1000", left: "0px" }}>
        {success ? (
          <Toast title={msjToast} timeClose={3000} close={() => setSuccess(false)} />
        ) : null}
        {error ? (
          <Toast
            type={"error"}
            title={msjToast}
            timeClose={3000}
            close={() => setError(false)}
          />
        ) : null}
      </div>
      <div className="importaciones">
        <div className="divLabel">
          <p className="titulo">{titulo()}</p>
        </div>
        <form className="formulario" onSubmit={handleSubmit}>
          <div className="divInputs">
            <div className="divUnoInput">
              <Input
                label="Cliente"
                classnamediv="divInputImportaciones divInput"
                className="input inputImportaciones"
                variant="outlined"
                size="medium"
                name="cliente"
                reactSelect
                options={clientes}
                value={selectedCliente}
                onChange={(e) => {
                  setSelectedCliente(e);
                  fetchOrdenes(e);
                }}
                placeholder={token.clienteId !== "" ? "Cliente" : selectedCliente === null ? "Seleccione un Cliente" : "Cliente"}
                isDisabled={token.clienteId !== "" || clientes.length < 1}
                isClearable
              />
              <Input
                label="Orden de Trabajo"
                classnamediv="divInputImportaciones divInput"
                className="input inputImportaciones"
                variant="outlined"
                size="medium"
                name="ordenTrabajo"
                reactSelect
                options={ordenes}
                value={selectedOrden}
                onChange={(e) => {
                  setSelectedOrden(e);
                }}
                placeholder={isLoadingOrdenes ? "Cargando..." : selectedCliente !== null && ordenes.length < 1 ? "No se encontraron ordenes" : selectedCliente !== null && selectedOrden === null ? "Seleccione una Orden" : "Orden de Trabajo"}
                isDisabled={ordenes.length < 1}
                isClearable
                isLoading={isLoadingOrdenes}
                showSubLabel
              />
            </div>
            <div className="divDosInput">
              <Checkboxx label="¿Reemplazar resultados?" name="remplazar" onChange={() => { setReemplazar(!reemplazar) }} value={reemplazar} />
              <DropZoneExcel archivos={rarFile} onUploadFiles={handleOnUploadArchivo} onClickDelete={(index, file) => { handleDeleteArchivo(index, file) }} />
            </div>
            <div className="divButtonsItem">
              {renderButtons()}
            </div>
          </div>
        </form>
      </div>
    </StyledModalcomponentMuestras>
  )
}

export default ImportacionDeResultadosModal